/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateTask} from '../api'

export const useMutationUpdateTask = createReactQueryMutationHook('updateTask', updateTask)
